export default __webpack_public_path__ + "static/media/pageNotFound.ecc6485c.svg";